import { IconName } from "@blueprintjs/core";

import { FieldSearch, SortQuery } from "../../redux/slices";
import { AccessUser } from "../../redux/slices/fast-server-api/types";
import { UseTableFiltersSelect } from "./hooks";

export const getSortIcon = (sort: SortQuery | null, field: string): IconName => {
  if (!sort) return "double-caret-vertical";

  if (sort.field === field) {
    if (sort.order === "DESC") return "caret-down";
    else return "caret-up";
  } else return "double-caret-vertical";
};

const EMPTY_FIELD_SEARCH: FieldSearch[] = [];
export const getFieldSearch = ({
  seasonMultiSelect,
  teamsMultiSelect,
  seriesMultiSelect,
  tagsMultiSelect,
  playNameFilter,
}: UseTableFiltersSelect): FieldSearch[] => {
  return [
    { field: "season", selectedItems: seasonMultiSelect.selectedItems },
    { field: "teamName", selectedItems: teamsMultiSelect.selectedItems },
    { field: "seriesName", selectedItems: seriesMultiSelect.selectedItems },
    { field: "tagName", selectedItems: tagsMultiSelect.selectedItems },
    { field: "playName", selectedItems: playNameFilter.length > 0 ? [{ label: playNameFilter }] : [] },
  ].reduce((acc, { field, selectedItems }): FieldSearch[] => {
    if (selectedItems.length) {
      return [...acc, { name: field, value: selectedItems.map((item) => item.label).join(",") }];
    } else return acc;
  }, EMPTY_FIELD_SEARCH);
};

interface isMobileAccessFilledInterface {
  activeUsers: AccessUser[];
  playRecipientIds: string[];
}

export const isMobileAccessFilled = ({ activeUsers, playRecipientIds }: isMobileAccessFilledInterface): boolean => {
  // if any of the playRecipientIds are in the activeUsers list, return true
  return playRecipientIds.some((id) => activeUsers.some((user) => user.userIdFormatted === id));
};
